import React from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import { doesIntegrationExist } from "@app/scene/settings/component/Sandbox/store";
import SandboxOption from "@app/scene/settings/component/Sandbox/type/SandboxOption";
import { RootState } from "@app/store/rootReducer";

import useSandboxOptions from "../../util/useSandboxOptions";

import OptionCheckBox from "./component/OptionCheckBox";
import styles from "./SandboxItems.module.scss";

interface Props {
  doesIntegrationExist: boolean;
}

const SandboxItems: React.FC<Props> = ({ doesIntegrationExist }) => {
  const intl = useIntl();
  const sandboxOptions: SandboxOption[] = useSandboxOptions(intl, doesIntegrationExist);

  return (
    <div>
      {sandboxOptions.map((option, index) => (
        <div className={styles.formItem} key={`sandbox-config-item-${index}`}>
          <OptionCheckBox option={option} />
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  doesIntegrationExist: doesIntegrationExist(state),
});

export default connect(mapStateToProps)(SandboxItems);
